/**
 * Видео и файл из вложений FAQ — общие для текста ответа и галереи под ним.
 *
 * Оба элемента строчные (phrasing content) намеренно: вложение из текста
 * markdown кладёт внутрь <p>, а блочный тег там — невалидный HTML и ошибка
 * гидратации. Обёртки вроде <figure> добавляет галерея, а не эти компоненты.
 *
 * Хуков здесь нет: компонент рендерится и на сервере (из FaqAnswer), и в
 * клиентской галерее.
 */

import { Download } from 'lucide-react';
import {
  faqAttachmentDownloadUrl,
  faqAttachmentUrl,
  formatFileSize,
  type FaqAttachment,
} from '@/lib/faq/attachments';

export function FaqVideoPlayer({ file, label }: { file: FaqAttachment; label?: string }) {
  return (
    <video
      src={faqAttachmentUrl(file)}
      controls
      preload="metadata"
      playsInline
      aria-label={label?.trim() || file.alt?.trim() || file.file_name}
      className="faq-video"
    >
      {/* Видит только браузер без <video> — там пусть хотя бы скачает */}
      <a href={faqAttachmentDownloadUrl(file)}>Download {file.file_name}</a>
    </video>
  );
}

export function FaqFileLink({ file, label }: { file: FaqAttachment; label?: string }) {
  const size = formatFileSize(file.size_bytes);

  return (
    <a
      href={faqAttachmentDownloadUrl(file)}
      className="faq-file-link inline-flex max-w-full items-center gap-2 cursor-pointer"
    >
      <Download size={16} aria-hidden="true" className="shrink-0" />
      <span className="break-all">{label?.trim() || file.file_name}</span>
      {size && <span className="shrink-0 text-sm text-text-secondary">{size}</span>}
    </a>
  );
}
